<script setup lang="ts">
import Button from '@/components/shared/Button.vue'
import Modal from '@/components/shared/Modal.vue'
import { isSessionExpired, sessionExpiredLoginUrl } from '@/lib/session-expiry'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const isLoginRoute = computed(() => /^\/account\/login(?:\/|$)/i.test(route.path))
const shouldShowModal = computed(() => isSessionExpired.value && !isLoginRoute.value)
</script>

<template>
  <Modal
    :open="shouldShowModal"
    :unmount="true"
    size="sm:max-w-[440px]"
    body-class="px-0 py-0"
  >
    <div class="px-6 pt-6 pb-5">
      <h2 class="text-lg font-semibold leading-6 text-gray-950 dark:text-gray-50">
        Your session has expired
      </h2>
      <p class="mt-2 text-sm leading-6 text-gray-600 dark:text-gray-300">
        Sign in again to continue from this page.
      </p>

      <div
        class="mt-5 rounded-md border border-gray-200 bg-gray-50 px-3 py-2.5 text-sm leading-5 text-gray-600 dark:border-gray-700 dark:bg-gray-900/70 dark:text-gray-300"
      >
        Background requests have been paused until you sign back in.
      </div>
    </div>

    <template #footer>
      <div class="flex justify-end">
        <Button
          type="primary"
          size="md"
          :href="sessionExpiredLoginUrl"
          :force-external="true"
        >
          Sign in
        </Button>
      </div>
    </template>
  </Modal>
</template>
